
$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.template-index').addClass('newClass');
       $('.Baby.kids').addClass('newClass');
    } else {
       $('.template-index').removeClass('newClass');
       $('.Baby.kids').removeClass('newClass');
    }
});



var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
     navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        "@0.00": {
          slidesPerView: 1.4,
          spaceBetween: 7,
        },
        "@0.75": {
          slidesPerView: 2,
          spaceBetween: 7,
        },
        "@1.00": {
          slidesPerView: 2,
          spaceBetween: 7,
        },
        "@1.50": {
          slidesPerView: 3,
          spaceBetween: 7,
        },
      },
    });



var swiper = new Swiper(".logoSwiper", {
      slidesPerView: 3,
      spaceBetween: 10,
   loop: true, // Infinite loop
  autoplay: {
    delay: 2000, // Auto-scroll every 2 seconds
    disableOnInteraction: false,
  },
     navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
     
      breakpoints: {
        "@0.00": {
          slidesPerView: 2,
          spaceBetween: 7,
        },
        "@0.75": {
          slidesPerView: 3,
          spaceBetween: 7,
        },
        "@1.00": {
          slidesPerView: 4,
          spaceBetween: 7,
        },
        "@1.50": {
          slidesPerView: 5,
          spaceBetween: 7,
        },
      },
    });

 // const swiper = new Swiper('.logoSwiper', {
 //    slidesPerView: 3,
 //    spaceBetween: 30,
 //    loop: true,
 //    autoplay: {
 //      delay: 2000,
 //      disableOnInteraction: false
 //    },
 //    navigation: {
 //      nextEl: '.swiper-button-next',
 //      prevEl: '.swiper-button-prev'
 //    },
 //    breakpoints: {
 //      320: {
 //        slidesPerView: 2,
 //        spaceBetween: 10
 //      },
 //      480: {
 //        slidesPerView: 3,
 //        spaceBetween: 10
 //      },
 //      768: {
 //        slidesPerView: 4,
 //        spaceBetween: 10
 //      },
 //      1024: {
 //        slidesPerView: 6,
 //        spaceBetween: 10
 //      }
 //    }
 //  });


// var swiper = new Swiper(".coll-list", {
//       slidesPerView: 1,
//       spaceBetween: 10,
  
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//   navigation: {                       //navigation(arrows)
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//       breakpoints: {
//         "@0.00": {
//           slidesPerView: 1.4,
//           spaceBetween: 7,
//         },
//         "@0.75": {
//           slidesPerView: 2,
//           spaceBetween: 7,
//         },
//         "@1.00": {
//           slidesPerView: 2,
//           spaceBetween: 7,
//         },
//         "@1.50": {
//           slidesPerView: 2,
//           spaceBetween: 7,
//         },
//       },
//     });


// Disable inspect element Right click and F12 key

// $(document).ready(function(){
// $(document).bind("contextmenu",function(e) {
//    e.preventDefault();});
// $(document).keydown(function(e){if(e.which === 123){return false; }});
// document.onkeydown = function(e) {
//   if(event.keyCode == 123) {return false;}
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {return false;}
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {return false;}
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {return false;}
//   if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {return false;}}});


// sss
$(document).ready(function(){
    $('.custom_faq_listing ul.faq_lists li.content-block .icon_acc').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        if ($this.next().hasClass('active')) {
            $this.next().removeClass('active');
            $this.removeClass('active');
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('.content-description').removeClass('active');
            $('.custom_faq_listing ul.faq_lists li.content-block .icon_acc').removeClass('active');
            $this.toggleClass('active');
            $this.parent().parent().find('.content-description').slideUp(350);
            $this.next().toggleClass('active');
            $this.next().slideToggle(350);
        }
    });
    
    $('.quick a').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var headerHeight = $('.shopify-section--header').outerHeight();

        $('html, body').animate({
            scrollTop: $(target).offset().top - headerHeight
        }, 500);
    });

});